import ElementBound from '../core/ElementBound';
import { getAppConfig } from 'larasnap';
import { Confirm, ctrlKeyDown } from 'larasnap/support';

export default class extends ElementBound {
    _ctrlKeyWasHeld = false;

    constructor(element) {
        super(element);
        element.attr('data-label-original', element.html());
        element.click(this.onClick.bind(this));
    }

    onClick() {
        this.captureCtrlKeyState();

        // First check if a panel method should be called
        if (this._element.attr('data-method')) {
            this.runPanelMethod('method', ...this.getParams());
        }
        // Otherwise dispatch the server route if it exists
        else if (this._element.attr('data-route')) {
            if (this._element.attr('data-route') === 'destroy') {
                this.confirmDestroy().then(({ isConfirmed }) => {
                    if (isConfirmed) {
                        this.dispatch();
                    }
                });
            } else {
                this.dispatch();
            }
        }
    }

    confirmDestroy() {
        const model = this.datamodel();
        const label = model?.getProps('label')
            ? ' ' + String(model.getProps('label')).toLowerCase()
            : '';

        if (model?.getProps('hasSoftDeletes')) {
            const numDays = getAppConfig('soft_deletes_retention_length');
            const labelPlural = model.getProps('labelPlural')
                ? ' ' + String(model.getProps('labelPlural')).toLowerCase()
                : 'items';

            return Confirm.delete({
                message: `
                    <p>Are you sure you want to trash this${label}?</p>               
                    <p>Trashed ${labelPlural} can be restored within ${numDays} days. After that they are automatically deleted.</p>                            
                `,
                confirmButtonText: 'Yes, Trash',
            });
        } else {
            return Confirm.delete({
                message: `Are you sure you want to delete this${label}?`,
            });
        }
    }

    dispatch() {
        this.prepareDispatch().send();
    }

    prepareDispatch() {
        return this.$http(this._element.data('route'), ...this.getParams());
    }

    $http(...params) {
        return this.panel()
            .$http(...params)
            .withButton(this);
    }

    attachHttpBuilder(builder) {
        builder
            .withLoadingState({
                apply: () => this.setLoadingState(true),
                remove: () => this.setLoadingState(false),
            })
            .addResponseInterceptor(response => {
                this.runPanelMethod('oncomplete', response.data);
                return response;
            });
    }

    runPanelMethod(prop, ...params) {
        const handler = this._element.attr(`data-${prop}`);
        if (handler && this.panel()) {
            this.panel().runFunction(handler, this, ...params);
        }
    }

    setLoadingState(isLoading) {
        const button = this._element;
        button.prop('disabled', isLoading);

        if (button.attr('data-verb')) {
            if (isLoading) {
                const spinner = '<i class="spinner pr-1"></i>';
                button.html(`${spinner} ${button.attr('data-verb')}`);
                button.addClass('state-loading');
            } else {
                button.html(button.attr('data-label-original'));
                button.removeClass('state-loading');
            }
        }
    }

    getParams() {
        const params = this._element.data('params');
        if (Array.isArray(params)) {
            return params;
        } else if (params) {
            return [params];
        } else {
            return [];
        }
    }

    captureCtrlKeyState() {
        this._ctrlKeyWasHeld = ctrlKeyDown;
    }

    ctrlKeyWasHeld() {
        return this._ctrlKeyWasHeld;
    }
}
